import { combineReducers } from '@reduxjs/toolkit';
import trackings from 'src/store/modules/trackings';
import editText from 'src/store/modules/editText';
import imageUpload from 'src/store/modules/imageUpload';
import buttons from 'src/store/modules/buttons';
import pages from 'src/store/modules/pages';
import client from 'src/store/modules/client';
import template from 'src/store/modules/template';
import modal from 'src/store/modules/modal';
import popup from 'src/store/modules/popup';
import customlog from 'src/store/modules/customlog';
import font from 'src/store/modules/font';
import switchButton from 'src/store/modules/switchButton';

const rootReducer = combineReducers({
  trackings,
  editText,
  imageUpload,
  buttons,
  pages,
  client,
  template,
  modal,
  popup,
  customlog,
  font,
  switchButton
});

export default rootReducer;
